import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem('mbu_cart');
      if (saved) setItems(JSON.parse(saved));
    } catch {
      window.localStorage.removeItem('mbu_cart');
    }
  }, []);

  useEffect(() => {
    window.localStorage.setItem('mbu_cart', JSON.stringify(items));
  }, [items]);

  const api = useMemo(
    () => ({
      items,
      add(priceId, qty = 1) {
        setItems((prev) => {
          const found = prev.find((i) => i.priceId === priceId);
          if (found)
            return prev.map((i) =>
              i.priceId === priceId ? { ...i, qty: i.qty + qty } : i
            );
          return [...prev, { priceId, qty }];
        });
      },
      remove(priceId) {
        setItems((prev) => prev.filter((i) => i.priceId !== priceId));
      },
      setQty(priceId, qty) {
        setItems((prev) => prev.map((i) => (i.priceId === priceId ? { ...i, qty } : i)));
      },
      clear() {
        setItems([]);
      },
    }),
    [items]
  );

  return <CartCtx.Provider value={api}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
